const getProjectInfo = () => {
    if (window.app) {
        const data = (window.app.getProjectInfo && JSON.parse(window.app.getProjectInfo())) || {};
        return data;
    }
    return {};
};
const appData = getProjectInfo();

const androidBack = () => {

    window.androids && window.androids.back();
};

const iosBack = () => {

    window.webkit && window.webkit.messageHandlers.iOSBack.postMessage(null);
};

const back = function (){

    if (appData.from === 'android') {
        androidBack();
    } else {
        iosBack();
    }

};

const androidBackToVideo = () => {

    window.androidVideoCheck && window.androidVideoCheck.checkVideo();
};

const iosBackToVideo = () => {

    window.webkit && window.webkit.messageHandlers.checkVideo.postMessage(null);
};

const backToVideo = function (){

    if (appData.from === 'android') {
        androidBackToVideo();
    } else {
        iosBackToVideo();
    }
};

const androidNotifyMenuBarLoaded = () => {

    window.androidMenuBarListener && window.androidMenuBarListener.menuBarLoaded();
};

const iosNotifyMenuBarLoaded = () => {

    window.webkit && window.webkit.messageHandlers.menuBarLoaded.postMessage(null);
};

const notifyMenuBarLoaded = () => {

    if (appData.from === 'android') {
        androidNotifyMenuBarLoaded();
    } else {
        iosNotifyMenuBarLoaded();
    }
};


export {
    back,
    backToVideo,
    getProjectInfo,
    notifyMenuBarLoaded
};
